import { Carousel } from '@mantine/carousel';
import {
  ActionIcon,
  Box,
  Button,
  Container,
  Flex,
  Group,
  HoverCard,
  Image,
  Menu,
  Modal,
  Paper,
  Rating,
  Text,
  createStyles,
  useMantineTheme,
  Global,
  Stack,
  ThemeIcon,
} from '@mantine/core';
import { motion, AnimatePresence } from 'framer-motion';
import {
  IconArrowsMaximize,
  IconHeart,
  IconMoneybag,
  IconPercentage,
  IconPlus,
  IconStar,
  IconStars,
  IconTrendingUp,
} from '@tabler/icons-react';
import { useContext, useEffect, useRef, useState } from 'react';
import { api } from '../../services/master.service';
import { image_url, is_mobile_view } from '../../config';
import { showErrorToast, showSuccessToast } from '../../utilities/Toast';
import { useNavigate } from 'react-router';
import { IconChevronRight } from '@tabler/icons';
import { IconSparkles, IconCoins, IconGift, IconDiamond, IconRocket, IconCrown, IconTrophy } from '@tabler/icons-react';
import ProductCard from '../../components/ProductCard';
import CustomSlider from '../../components/CustomSlider';
import { useMediaQuery } from '@mantine/hooks';
import { CartContext } from '../../App';
import { qtyCalculator } from '../../utilities/Common'



const useStyles = createStyles((theme) => ({
  link: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    height: '100%',
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.md,
    textDecoration: 'none',
    color: theme.colorScheme === 'dark' ? theme.white : theme.black,
    fontWeight: 500,
    fontSize: theme.fontSizes.sm,

    [theme.fn.smallerThan('sm')]: {
      height: 42,
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
    }),
  },

  subLink: {
    width: '100%',
    padding: `${theme.spacing.xs} ${theme.spacing.md}`,
    borderRadius: theme.radius.md,

    ...theme.fn.hover({
      backgroundColor:
        theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    }),

    '&:active': theme.activeStyles,
  },

  dropdownFooter: {
    backgroundColor:
      theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.colors.gray[0],
    margin: `calc(${theme.spacing.md} * -1)`,
    marginTop: theme.spacing.sm,
    padding: `${theme.spacing.md} calc(${theme.spacing.md} * 2)`,
    paddingBottom: theme.spacing.xl,
    borderTop: `${1} solid ${theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1]
      }`,
  },

  hiddenMobile: {
    [theme.fn.smallerThan('sm')]: {
      display: 'none',
    },
  },

  hiddenDesktop: {
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },
}));

export default function Home() {
  const theme = useMantineTheme();
  const navigate = useNavigate();
  const { classes } = useStyles();
  let isMobileScreen = useMediaQuery('(max-width: 768px)');
  const banner_view = is_mobile_view && !isMobileScreen;
  isMobileScreen = is_mobile_view ? is_mobile_view : isMobileScreen;
  const { cartItemCount, setCartItemCount } = useContext(CartContext);

  const [quickViewModalVisible, setQuickViewModalVisible] = useState(false);
  const [heroBanners, setHeroBanners] = useState([]);
  const [bottomBanners, setBottomBanners] = useState([]);
  const [midBanners, setMidBanners] = useState([]);
  const [affliatorBanners, setAffliatorBanners] = useState([]);

  const [latestProducts, setLatestProducts] = useState([]);
  const [dealProducts, setDealProducts] = useState([]);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [openStickyMenu, setOpenStickyMenu] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const specialDealsEmblaApi = useRef(null);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const referralCode = user?.referral_code || null;
  const desktopHeroHeight = 400;
  const desktopSideBannerGap = 14;

  const shareUrl =
    `https://play.google.com/store/apps/details?id=com.postulate.quzone&pcampaignid=web_share&ref=${referralCode}`;
  const shareMessage = `
    🎉 Join Quzone & Get a Coupon!

    Use my referral code during login:
    👉 \`${referralCode}\`

    🎁 You’ll get a coupon on signup.

    Download the app here:
    ${shareUrl}
    `;
  const mobileTopBanners = affliatorBanners.slice(0, 2);
  const hasProductContent = (product) => {
    const thumbnail = product?.thumbnail?.toString().trim();
    const title = product?.title?.toString().trim();
    const currentPrice = product?.active_batches?.[0]?.selling_price ?? product?.price;
    const currentMrp = product?.active_batches?.[0]?.mrp ?? product?.mrp;

    return Boolean(
      product?.id &&
      title &&
      thumbnail &&
      thumbnail !== 'null' &&
      thumbnail !== 'undefined' &&
      Number.isFinite(Number(currentPrice)) &&
      Number.isFinite(Number(currentMrp))
    );
  };
  const visibleLatestProducts = latestProducts.filter(hasProductContent);
  const visibleDealProducts = dealProducts.filter(hasProductContent);
  const visibleFeaturedProducts = featuredProducts.filter(hasProductContent);
  const renderMobileProductRow = (products, onAddToCart) => (
    <Box
      sx={{
        display: 'flex',
        gap: 12,
        overflowX: 'auto',
        overflowY: 'hidden',
        paddingBottom: 6,
        scrollSnapType: 'x mandatory',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      {products.map((e) => (
        <Box
          key={e.id}
          sx={{
            flex: '0 0 calc((100% - 12px) / 2)',
            maxWidth: 'calc((100% - 12px) / 2)',
            scrollSnapAlign: 'start',
          }}
        >
          <ProductCard
            object={e}
            addToCart={onAddToCart}
          />
        </Box>
      ))}
    </Box>
  );

  const stickyMenuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openStickyMenu &&
        stickyMenuRef.current &&
        !stickyMenuRef.current.contains(event.target)
      ) {
        setOpenStickyMenu(false);
      }
    };

    document.addEventListener("pointerdown", handleClickOutside);

    return () => {
      document.removeEventListener("pointerdown", handleClickOutside);
    };
  }, [openStickyMenu]);




  const addToCart = async (id, varient, unit = "pkt", isVarient) => {
    await api
      .add_to_cart({
        product_id: id,
        quantity: qtyCalculator(1, varient, isVarient ? unit : 'pkt', isVarient),
        varientSlug: `${varient}${isVarient ? unit : 'pkt'} x 1`
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success) {
          // setCartItemCount(res.data.data?.cartitem.length);
          const data = res.data.data;
          const productRows = data.cartitem?.filter(item => item.bundle === null).length ?? 0;
          const bundleRows = data.cart_bundles?.length ?? 0;
          setCartItemCount(productRows + bundleRows);
          showSuccessToast({
            title: 'Success',
            message: 'Item successfully added to cart.',
          });
        } else {
          if (res.data.code === 401) {
            navigate('/login');
            showErrorToast({
              title: 'Warning',
              message: 'You have to login to add items to cart.',
            });
          } else {
            showErrorToast({
              title: 'Error',
              message: res.data.message,
            });
          }
        }
      })
      .catch((err) => {
        showErrorToast({
          title: 'Error',
          message: err.message,
        });
      });
  };

  useEffect(() => {
    api.get_home_products({ filter: 'latest' }).then((res) => {
      console.log(res.data.data);
      setLatestProducts(res.data.data);
    });

    api.get_home_products({ filter: 'deals' }).then((res) => {
      console.log(res.data.data);
      setDealProducts(res.data.data);
    });

    api.get_home_products({ filter: 'featured' }).then((res) => {
      console.log(res.data.data);
      setFeaturedProducts(res.data.data);
    });

    api.get_banners().then((res) => {
      console.log(res.data.data);
      let hero_banners = res.data.data.filter((e) => e.home_banner === true);
      setHeroBanners(hero_banners);
      let bottom_banners = res.data.data.filter((e) => e.bottom_banner === true);
      setBottomBanners(bottom_banners);
      let mid_banners = res.data.data.filter((e) => e.mid_banner === true);
      setMidBanners(mid_banners);
      let affliator_banners = res.data.data.filter((e) => e.affliator_banner === true);
      setAffliatorBanners(affliator_banners);
    });
  }, []);

  useEffect(() => {
    api.get_categories().then((res) => {
      console.log(res.data.data);
      setCategories(res.data.data);
    });
  }, []);

  // Autoplay for Special Deals
  useEffect(() => {
    const interval = setInterval(() => {
      if (specialDealsEmblaApi.current) {
        if (specialDealsEmblaApi.current.canScrollNext()) {
          specialDealsEmblaApi.current.scrollNext();
        } else {
          specialDealsEmblaApi.current.scrollTo(0);
        }
      }
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      overflow: 'hidden',
      marginTop: isMobileScreen ? '135px' : '170px',
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : '#fcfcfc'
    }}>
      <Global
        styles={(theme) => ({
          '.slick-prev::before, .slick-next::before': {
            color: '#5bc680 !important',
            fontSize: '20px',
          },
          '.mantine-4o0tuq': {
            color: 'white',
            backgroundColor: '#5bc680 !important',
          },
          '.home-hero-slider .slick-prev, .home-hero-slider .slick-next': {
            zIndex: 3,
            width: 28,
            height: 28,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(22,101,52,0.95), rgba(91,198,128,0.95))',
            border: 'none',
            boxShadow: '0 7px 16px rgba(22,101,52,0.24)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease',
          },
          '.home-hero-slider .slick-prev': {
            left: -14,
          },
          '.home-hero-slider .slick-next': {
            right: -14,
          },
          '.home-hero-slider .slick-prev:hover, .home-hero-slider .slick-next:hover': {
            background: 'linear-gradient(135deg, #0f8f45, #66d68f)',
            boxShadow: '0 9px 20px rgba(22,101,52,0.3)',
            filter: 'saturate(1.08)',
            transform: 'translateY(-1px) scale(1.04)',
          },
          '.home-hero-slider .slick-prev::before, .home-hero-slider .slick-next::before': {
            color: '#ffffff !important',
            fontSize: '13px',
            lineHeight: 1,
            opacity: 1,
            textShadow: '0 1px 3px rgba(0,0,0,0.18)',
          },
          '.home-hero-slider .slick-list': {
            overflow: 'hidden',
          },
          '.home-hero-slider .slick-track': {
            display: 'flex',
          },
          '.home-hero-slider .slick-slide': {
            overflow: 'hidden',
          },
          '.home-hero-slider .slick-slide > div': {
            height: '100%',
            overflow: 'hidden',
          },
          '.bottom-promo-slider .slick-prev, .bottom-promo-slider .slick-next': {
            zIndex: 3,
            width: 30,
            height: 30,
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(22,101,52,0.95), rgba(91,198,128,0.95))',
            border: 'none',
            boxShadow: '0 7px 16px rgba(22,101,52,0.24)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease',
          },
          '.bottom-promo-slider .slick-prev': {
            left: -15,
          },
          '.bottom-promo-slider .slick-next': {
            right: -15,
          },
          '.bottom-promo-slider .slick-prev:hover, .bottom-promo-slider .slick-next:hover': {
            background: 'linear-gradient(135deg, #0f8f45, #66d68f)',
            boxShadow: '0 9px 20px rgba(22,101,52,0.3)',
            filter: 'saturate(1.08)',
            transform: 'translateY(-1px) scale(1.04)',
          },
          '.bottom-promo-slider .slick-prev::before, .bottom-promo-slider .slick-next::before': {
            color: '#ffffff !important',
            fontSize: '14px',
            lineHeight: 1,
            opacity: 1,
            textShadow: '0 1px 3px rgba(0,0,0,0.18)',
          },
          '.bottom-promo-slider .slick-list, .bottom-promo-slider .slick-track, .bottom-promo-slider .slick-slide, .bottom-promo-slider .slick-slide > div': {
            lineHeight: 0,
          },
        })}
      />

      {/* STICKY FLOATING MENU (Kept for functionality) */}
      <Box
        ref={stickyMenuRef}
        sx={{
          position: 'fixed',
          right: openStickyMenu ? 18 : -18,
          top: isMobileScreen ? 200 : 220,
          zIndex: 9999,
          transition: 'right 0.35s ease',
        }}
      >
        <Paper
          shadow="xl"
          radius="xl"
          px={openStickyMenu ? 26 : 8}
          py={openStickyMenu ? 22 : 8}
          sx={{
            minWidth: openStickyMenu ? 180 : 44,
            minHeight: openStickyMenu ? 140 : 44,
            background: openStickyMenu
              ? 'linear-gradient(145deg, #22c55e, #16a34a, #15803d)'
              : '#5bc680',
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: openStickyMenu ? 18 : 0,
            border: openStickyMenu ? '1px solid rgba(255,255,255,0.25)' : 'none',
            transition: 'all 0.35s ease',
          }}
        >
          <ActionIcon
            radius="xl"
            size="lg"
            onClick={() => setOpenStickyMenu(!openStickyMenu)}
            sx={{
              backgroundColor: openStickyMenu ? '#ecfdf5' : '#ffffff',
              color: '#166534',
              boxShadow: openStickyMenu
                ? '0 6px 18px rgba(22,163,74,0.45)'
                : '0 6px 18px rgba(0,0,0,0.25)',
              transition: 'all 0.35s ease',
            }}
          >
            <style>
              {`
                @keyframes rainbowStroke {
                  0%   { stroke: red; }
                  16%  { stroke: orange; }
                  33%  { stroke: yellow; }
                  50%  { stroke: green; }
                  66%  { stroke: blue; }
                  83%  { stroke: indigo; }
                  100% { stroke: violet; }
                }
              `}
            </style>
            <IconGift
              size={29}
              stroke={2.5}
              style={{
                transform: openStickyMenu ? 'rotate(360deg)' : 'rotate(0deg)',
                transition: 'transform 0.5s ease',
                animation: "rainbowStroke 1s linear infinite",
                filter: "drop-shadow(0 0 4px rgba(255,255,255,0.6))"
              }}
            />
          </ActionIcon>

          {openStickyMenu && (
            <Flex direction="column" gap={16} mt={10} w="100%">
              <Box
                onClick={() => { setShareModalOpen(true); setOpenStickyMenu(false); }}
                sx={{
                  padding: '14px 18px',
                  borderRadius: 18,
                  background: 'linear-gradient(145deg, rgba(255,255,255,0.18), rgba(255,255,255,0.08))',
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  cursor: 'pointer',
                  transition: 'all 0.35s ease',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.2)',
                  '&:hover': { transform: 'translateY(-3px)' },
                }}
              >
                <Box sx={{ width: 38, height: 38, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🔗</Box>
                <Flex direction="column"><Text fw={700} size="sm">Share</Text><Text size="xs" opacity={0.7}>Invite friends</Text></Flex>
              </Box>
              <Box
                onClick={() => navigate('/account', { state: { openTab: 'referral' } })}
                sx={{
                  padding: '14px 18px',
                  borderRadius: 18,
                  background: 'linear-gradient(145deg, rgba(255,255,255,0.18), rgba(255,255,255,0.08))',
                  backdropFilter: 'blur(10px)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  cursor: 'pointer',
                  transition: 'all 0.35s ease',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.2)',
                  '&:hover': { transform: 'translateY(-3px)' },
                }}
              >
                <Box sx={{ width: 38, height: 38, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🎁</Box>
                <Flex direction="column"><Text fw={700} size="sm">Referral</Text><Text size="xs" opacity={0.7}>Earn coupons</Text></Flex>
              </Box>
            </Flex>
          )}
        </Paper>
      </Box>

      {/* CATEGORY SCROLLBAR (Circular App Icons) */}
      <Box
        py={20}
        sx={{
          backgroundColor: theme.white,
          borderBottom: `1px solid ${theme.colors.gray[1]}`,
          display: isMobileScreen ? 'none' : 'block',
        }}
      >
        <Container size="xl">
          <Flex gap="xl" sx={{ overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none' }, padding: '4px 10px' }}>
            {categories.map((cat, idx) => (
              <motion.div
                key={cat.id}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.05 }}
                style={{ textAlign: 'center', cursor: 'pointer', flexShrink: 0 }}
                onClick={() => {
                  if (cat.id === 41 || cat.title === "Bundles") {
                    navigate("/bundles");
                  } else {
                    navigate(`/category?id=${cat.id}`);
                  }
                }}
              >
                <Box
                  sx={{
                    width: 70,
                    height: 70,
                    borderRadius: '50%',
                    backgroundColor: theme.colors.gray[0],
                    border: `2px solid ${theme.colors.gray[1]}`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.1)',
                      borderColor: theme.colors.brand[5],
                      boxShadow: theme.shadows.md
                    }
                  }}
                >
                  <Image
                    src={image_url + cat.image}
                    alt={cat.title}
                    width="100%"
                    height="100%"
                    fit="cover"
                  />
                </Box>
                <Text size={12} fw={600} mt={8} color="dimmed" sx={{ maxWidth: 80 }} lineClamp={1}>
                  {cat.title}
                </Text>
              </motion.div>
            ))}
          </Flex>
        </Container>
      </Box>

      <Container
        size="xl"
        pt={isMobileScreen ? 24 : 20}
        pb={0}
        px={isMobileScreen ? 16 : undefined}
      >
        {isMobileScreen ? (
          <>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                gap: 14,
                marginTop: 2,
              }}
            >
              {mobileTopBanners.map((e) => (
                <Paper
                  key={`${e.id}-${e.image}`}
                  radius={0}
                  sx={{
                    overflow: 'hidden',
                    aspectRatio: '1 / 1',
                    backgroundColor: '#f8fafc',
                    boxShadow: 'none',
                  }}
                  onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                >
                  <Image
                    src={image_url + e.image}
                    height="100%"
                    fit="cover"
                    alt="Banner"
                    style={{ cursor: e.product ? 'pointer' : 'default' }}
                  />
                </Paper>
              ))}
            </Box>

            {heroBanners.length > 0 && (
              <Box
                mt={40}
                className="home-hero-slider"
                sx={{
                  overflow: 'visible',
                  aspectRatio: '2.5 / 1',
                  boxShadow: 'none',
                  '.slick-slider, .slick-list, .slick-track, .slick-slide, .slick-slide > div': {
                    height: '100%',
                  },
                }}
              >
                <CustomSlider slidesToShow={1}>
                  {heroBanners.map((e) => (
                    <div
                      key={e.id}
                      onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                      style={{
                        cursor: e.product ? 'pointer' : 'default',
                        height: '100%',
                        overflow: 'hidden',
                      }}
                    >
                      <img
                        src={image_url + e.image}
                        alt="Hero Banner"
                        style={{
                          width: '100%',
                          height: '100%',
                          marginLeft: -1,
                          marginTop: -1,
                          display: 'block',
                          objectFit: 'cover',
                          objectPosition: 'center',
                          minWidth: 'calc(100% + 2px)',
                          minHeight: 'calc(100% + 2px)',
                        }}
                      />
                    </div>
                  ))}
                </CustomSlider>
              </Box>
            )}

            {visibleLatestProducts.length > 0 && (
              <Box mt={24}>
                <Group spacing={10} mb={16} noWrap>
                  <ThemeIcon variant="light" color="blue" size={42} radius="lg">
                    <IconStars size={24} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl">New Arrivals</Text>
                    <Text size="xs" color="dimmed">Freshly added to our store</Text>
                  </Box>
                </Group>

                {renderMobileProductRow(visibleLatestProducts, addToCart)}
              </Box>
            )}

            {midBanners.length > 0 && (
              <Box mt={36}>
                <Flex justify="space-between" align="center" mb={14}>
                  <Group spacing={10}>
                    <ThemeIcon variant="light" color="green" size={42} radius="lg">
                      <IconPercentage size={24} />
                    </ThemeIcon>
                    <Box>
                      <Text fw={800} size="xl">
                        Special Deals
                      </Text>
                      <Text size="xs" color="dimmed">
                        Exclusive offers just for you
                      </Text>
                    </Box>
                  </Group>
                </Flex>

                <Carousel
                  getEmblaApi={(api) => (specialDealsEmblaApi.current = api)}
                  slideSize="100%"
                  slideGap="md"
                  align="start"
                  slidesToScroll={1}
                  withControls={false}
                  dragFree={false}
                >
                  {midBanners.map((e) => (
                    <Carousel.Slide key={e.id}>
                      <Paper
                        radius={0}
                        sx={{
                          overflow: 'hidden',
                          aspectRatio: '1.7 / 1',
                          backgroundColor: '#161616ff',
                          boxShadow: 'none',
                          cursor: e.product ? 'pointer' : 'default',
                        }}
                        onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                      >
                        <Image
                          src={image_url + e.image}
                          height="100%"
                          fit="fill"
                          alt="Special Deal"
                        />
                      </Paper>
                    </Carousel.Slide>
                  ))}
                </Carousel>
              </Box>
            )}

            {visibleDealProducts.length > 0 && (
              <Box mt={36}>
                <Group spacing={10} mb={16} noWrap>
                  <ThemeIcon variant="filled" color="red" size={42} radius="lg">
                    <IconPercentage size={24} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl" color="red.9">Hot Deals</Text>
                    <Text size="xs" color="red.6">Limited time price drops</Text>
                  </Box>
                </Group>

                {renderMobileProductRow(visibleDealProducts, addToCart)}
              </Box>
            )}

            {visibleFeaturedProducts.length > 0 && (
              <Box mt={36}>
                <Group spacing={10} mb={16} noWrap>
                  <ThemeIcon variant="light" color="orange" size={42} radius="lg">
                    <IconTrendingUp size={24} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl">Trending Now</Text>
                    <Text size="xs" color="dimmed">Most popular choices this week</Text>
                  </Box>
                </Group>

                {renderMobileProductRow(visibleFeaturedProducts, addToCart)}
              </Box>
            )}

            {bottomBanners.length > 0 && (
              <Box mt={40} className="bottom-promo-slider" sx={{ overflow: 'hidden', lineHeight: 0 }}>
                <CustomSlider slidesToShow={1}>
                  {bottomBanners.map((e) => (
                    <div
                      key={e.id}
                      onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                      style={{ cursor: e.product ? 'pointer' : 'default', height: '100%' }}
                    >
                      <img
                        src={image_url + e.image}
                        alt="Bottom Banner"
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  ))}
                </CustomSlider>
              </Box>
            )}
          </>
        ) : (
          <>
            {/* HERO SECTION */}
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: isMobileScreen ? '1fr' : 'minmax(0, 1fr) 220px',
                  gap: isMobileScreen ? 12 : 22,
                  alignItems: 'start',
                }}
              >
                <Box>
                  <Paper
                    radius="md"
                    className="home-hero-slider"
                    sx={{
                      overflow: 'visible',
                      boxShadow: 'none',
                      height: isMobileScreen ? 'auto' : desktopHeroHeight,
                      aspectRatio: isMobileScreen ? '2.5 / 1' : 'auto',
                      backgroundColor: 'transparent',
                      '.slick-slider, .slick-list, .slick-track, .slick-slide, .slick-slide > div': {
                        height: '100%',
                      },
                    }}
                  >
                    <CustomSlider slidesToShow={1}>
                      {heroBanners.map((e) => (
                        <div
                          key={e.id}
                          onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                          style={{
                            cursor: e.product ? 'pointer' : 'default',
                            height: '100%',
                            overflow: 'hidden',
                          }}
                        >
                          <img
                            src={image_url + e.image}
                            alt="Hero Banner"
                            style={{
                              width: '100%',
                              height: '100%',
                              marginLeft: -1,
                              marginTop: -1,
                              display: 'block',
                              objectFit: 'cover',
                              objectPosition: 'center',
                              minWidth: 'calc(100% + 2px)',
                              minHeight: 'calc(100% + 2px)',
                            }}
                          />
                        </div>
                      ))}
                    </CustomSlider>
                  </Paper>
                </Box>
                <Box>
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: isMobileScreen ? 'repeat(2, minmax(0, 1fr))' : '1fr',
                      gap: isMobileScreen ? 12 : 14,
                    }}
                  >
                    {affliatorBanners.slice(0, 2).map((e) => (
                      <Paper
                        key={e.id}
                        radius="md"
                        sx={{
                          overflow: 'hidden',
                          boxShadow: 'none',
                          height: isMobileScreen
                            ? 'auto'
                            : (desktopHeroHeight - desktopSideBannerGap) / 2,
                          aspectRatio: isMobileScreen ? '1 / 1' : 'auto',
                          width: '100%',
                          backgroundColor: '#f8fafc',
                          cursor: e.product ? 'pointer' : 'default',
                        }}
                        onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                      >
                        <img
                          src={image_url + e.image}
                          alt="Banner"
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'block',
                            objectFit: 'fill',
                            objectPosition: 'center',
                          }}
                        />
                      </Paper>
                    ))}
                  </Box>
                </Box>
              </Box>
            </motion.div>

            {/* NEW ARRIVALS */}
            <Box my={60}>
              <Flex justify="space-between" align="center" mb={24}>
                <Group>
                  <ThemeIcon variant="light" color="blue" size={48} radius="lg">
                    <IconStars size={28} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl">New Arrivals</Text>
                    <Text size="xs" color="dimmed">Freshly added to our store</Text>
                  </Box>
                </Group>
                <Button variant="subtle" rightIcon={<IconChevronRight size={14} />} onClick={() => navigate('/products')}>
                  View All
                </Button>
              </Flex>

              <Carousel
                slideSize={isMobileScreen ? '60%' : '25%'}
                slideGap="xl"
                align="start"
                slidesToScroll={1}
                withControls={!isMobileScreen}
                dragFree
              >
                {visibleLatestProducts.map((e) => (
                  <Carousel.Slide key={e.id}>
                    <ProductCard object={e} addToCart={addToCart} />
                  </Carousel.Slide>
                ))}
              </Carousel>
            </Box>

            {/* MID BANNERS - Special Deals Carousel */}
            <Box my={60}>
              <Flex justify="space-between" align="center" mb={24}>
                <Group>
                  <ThemeIcon variant="light" color="green" size={48} radius="lg">
                    <IconPercentage size={28} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl">Special Deals</Text>
                    <Text size="xs" color="dimmed">Exclusive offers just for you</Text>
                  </Box>
                </Group>
              </Flex>

              <Carousel
                getEmblaApi={(api) => (specialDealsEmblaApi.current = api)}
                slideSize={isMobileScreen ? '100%' : 'calc((100% - 24px) / 2)'}
                slideGap={24}
                align="start"
                slidesToScroll={1}
                withControls={!isMobileScreen}
                dragFree={false}
                styles={{
                  control: {
                    '&[data-inactive]': {
                      opacity: 0,
                      cursor: 'default',
                    },
                  },
                }}
              >
                {midBanners.map((e) => (
                  <Carousel.Slide key={e.id}>
                    <Paper
                      radius="lg"
                      sx={{
                        overflow: 'hidden',
                        boxShadow: theme.shadows.sm,
                        cursor: 'pointer',
                        transition: 'transform 0.2s ease',
                        '&:hover': { transform: 'scale(1.02)' }
                      }}
                      onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                    >
                      <Image
                        src={image_url + e.image}
                        height={isMobileScreen ? 180 : 320}
                        fit="fill"
                        alt="Special Deal"
                      />
                    </Paper>
                  </Carousel.Slide>
                ))}
              </Carousel>
            </Box>

            {/* HOT DEALS */}
            <Box my={60} sx={{
              backgroundColor: 'rgba(255, 107, 107, 0.05)',
              margin: '0 -20px',
              padding: '60px 20px',
              borderRadius: isMobileScreen ? 0 : 32
            }}>
              <Flex justify="space-between" align="center" mb={24}>
                <Group>
                  <ThemeIcon variant="filled" color="red" size={48} radius="lg">
                    <IconPercentage size={28} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl" color="red.9">Hot Deals</Text>
                    <Text size="xs" color="red.6">Limited time price drops</Text>
                  </Box>
                </Group>
              </Flex>

              <Carousel
                slideSize={isMobileScreen ? '60%' : '25%'}
                slideGap="xl"
                align="start"
                slidesToScroll={1}
                withControls={!isMobileScreen}
                dragFree
              >
                {visibleDealProducts.map((e) => (
                  <Carousel.Slide key={e.id}>
                    <ProductCard object={e} addToCart={addToCart} />
                  </Carousel.Slide>
                ))}
              </Carousel>
            </Box>

            {/* TRENDING */}
            <Box my={60}>
              <Flex justify="space-between" align="center" mb={24}>
                <Group>
                  <ThemeIcon variant="light" color="orange" size={48} radius="lg">
                    <IconTrendingUp size={28} />
                  </ThemeIcon>
                  <Box>
                    <Text fw={800} size="xl">Trending Now</Text>
                    <Text size="xs" color="dimmed">Most popular choices this week</Text>
                  </Box>
                </Group>
              </Flex>

              <Carousel
                slideSize={isMobileScreen ? '60%' : '25%'}
                slideGap="xl"
                align="start"
                slidesToScroll={1}
                withControls={!isMobileScreen}
                dragFree
              >
                {visibleFeaturedProducts.map((e) => (
                  <Carousel.Slide key={e.id}>
                    <ProductCard object={e} addToCart={addToCart} />
                  </Carousel.Slide>
                ))}
              </Carousel>
            </Box>

            {/* BOTTOM PROMO */}
            <Box mb={0} mt={60}>
              <Box className="bottom-promo-slider" sx={{ overflow: 'visible', lineHeight: 0 }}>
                <CustomSlider
                  slidesToShow={1}
                  showArrowsOnMobile
                >
                  {bottomBanners.map((e) => (
                    <div
                      key={e.id}
                      onClick={() => e.product && navigate(`/product?id=${e.product}`)}
                      style={{ cursor: e.product ? 'pointer' : 'default', lineHeight: 0 }}
                    >
                      <img
                        src={image_url + e.image}
                        alt="Bottom Banner"
                        style={{
                          width: '100%',
                          height: 'auto',
                          display: 'block',
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                  ))}
                </CustomSlider>
              </Box>
            </Box>
          </>
        )}
      </Container>

      {/* SHARE DRAWER-LIKE MODAL */}
      <Modal
        opened={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        centered
        radius="lg"
        size="sm"
        overlayProps={{ blur: 4, opacity: 0.6 }}
        title={<Text fw={800}>Share App</Text>}
      >
        <Stack spacing="lg">
          <Button
            component="a"
            href={`https://wa.me/?text=${encodeURIComponent(shareMessage.trim())}`}
            target="_blank"
            fullWidth
            radius="md"
            size="lg"
            leftIcon={<Image src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" width={24} />}
            sx={{ background: '#25D366', boxShadow: '0 8px 20px rgba(37,211,102,0.3)', '&:hover': { background: '#1ebe5d' } }}
          >
            WhatsApp
          </Button>

          <Paper radius="md" p="md" withBorder sx={{ backgroundColor: '#f8fafc' }}>
            <Text size="xs" color="dimmed" lineClamp={3} mb={12}>{shareMessage.trim()}</Text>
            <Button
              variant="light"
              fullWidth
              radius="md"
              onClick={() => {
                navigator.clipboard.writeText(shareMessage.trim());
                showSuccessToast({ title: "Copied!", message: "Link ready to share." });
              }}
            >
              📋 Copy Link
            </Button>
          </Paper>
        </Stack>
      </Modal>

      <Modal
        centered
        opened={quickViewModalVisible}
        onClose={() => setQuickViewModalVisible(false)}
        size="lg"
        radius="lg"
      >
        {/* Quick view content if needed */}
      </Modal>
    </div>
  );
}
